const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Where Insight Meets Strategy</h1>
        <p>
          Analyze markets like never before with The Pips Analytical Tools,
          built to help you trade smarter, faster, and more confidently.
          {/* Whether you’re hedging against inflation or capitalizing on short-term
          price shifts, The Pips provides an intuitive platform for both
          precision and performance. */}
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
